export default {
      id: "icon-clock-usage",
      viewBox: "0 0 465.2 465.2",
      url: __webpack_public_path__ + "icons.svg#icon-clock",
      toString: function () {
        return this.url;
      }
    }